var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle2, _path23, _circle3, _path24, _circle4, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManWithProgressbarYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 700.747 597.777"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "m618.388 595.447.016-.697a80.53 80.53 0 0 1 30.112-60.643 78.1 78.1 0 0 1 16.786-10.116l.572-.254.097.618c1.162 7.38 3.001 14.913 3.858 18.256l5.744-22.414.639-.184a15.27 15.27 0 0 1 16.303 5.208 15.53 15.53 0 0 1 1.611 17.332c-1.338 2.495-2.655 5.097-3.928 7.614-4.374 8.65-8.896 17.593-15.487 24.542a48.68 48.68 0 0 1-39.26 14.645Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m546.768 585.081-9.995-.001-4.756-38.556 14.753.001z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m547.12 595.509-30.738-.001v-.39a11.965 11.965 0 0 1 11.964-11.963l5.616-4.26 10.476 4.26h2.683Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m650.238 556.92-7.897 6.128-27.397-27.543 11.655-9.045z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m656.91 564.941-24.284 18.847-.238-.308a11.965 11.965 0 0 1 2.116-16.787l1.824-6.808 10.888-3.058 2.12-1.645ZM607 370.373s-.682 10.439-1.543 25.362c-.14 2.447.691 5.106.543 7.768-.099 1.767-1.176 3.484-1.276 5.326-.106 1.943 1.382 3.664 1.276 5.674-.104 1.964-1.801 4.217-1.903 6.227-1.102 21.634-5.097 47.533-1.097 54.773 1.971 3.568 32 53 32 53s-14 21-18 14c-5.283-9.245-46-52.5-46-60.76 0-8.25-9.42-70.08-9.42-70.08l-6.568 36.59-3.012 7.25.946 4.256-1.946 5.744-.105 5.685L549 481.743s5.7 82.24 2.49 84.53c-3.22 2.3-18.81 6.43-20.65 2.3-1.83-4.13-8.84-85.83-8.84-85.83s-1.92-37.44-4-72.24c-.12-2.02-1.54-4.46-1.65-6.45-.13-2.31.77-5.31.65-7.55-.13-2.57-1.27-4.38-1.38-6.84-.85-19.01-.98-33.99.54-36.27 4.59-6.88 8.72-12.38 8.72-12.38s65.6-16.06 82.12 4.58Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "m548 173.503 15.817-.884 11.92 6.507 33.148 187.715S575 382.503 554 376.503s-43.115-5.662-43.115-5.662L527 191.503l13-12Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m574.388 177.483 24.483 9.998a16.66 16.66 0 0 1 15.584 13.668L612.83 249.5 604 272.503l6.297 52.4-3.297 6.6 2.849 6.737c-4.182 6.789-3.33 15.685-.849 25.263h-3l-6-1s-13.21 4.586-15.916-11.885C577 307.503 573 326.503 573 326.503l-3.487-133.772ZM541 177.503l-22.87 23.978a16.66 16.66 0 0 0-15.585 13.668L512 289.503l-4.437 28.53 2.437 6.47-1.765 7.313 2.765 6.687-2 9 3 13 15-4-.115-10.662 4-145Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m464.727 300.76-31.154 22.607a6.803 6.803 0 1 0 6.422 9.866l42.364-22.616Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M508 205.503c-5.921 2.731-20.549 72.652-24.842 74.134s-2.654 1.26-3.256 2.497-.748 6.78-4.87 7.43-25.895 20.502-25.895 20.502l5.52 18.4s41.9-23.94 53.454-37.196 17.774-81.429 17.774-81.429l1.182-6.801s-13.146-.268-19.067 2.463"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m601.962 291.528-27.765 26.661a6.803 6.803 0 1 0 7.713 8.894l38.868-28.205Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M606 211.503c-5.491 3.517 15.375 54.52 11.326 56.577s-2.457 1.611-2.884 2.92.188 6.818-3.805 8.026-22.844 23.856-22.844 23.856l7.988 17.47s38.227-29.453 47.856-44.167S647 256.503 647 256.503c-11.946-25.372-23.12-66.75-40-64 0 0 4.491 15.484-1 19"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 551.392,
  cy: 142.737,
  r: 26.807,
  fill: "#ffb6b6"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M578.538 160.01s-5.904 1.62-9.34 2.52c.178-2.556 1.285-4.95 1.847-7.45s.44-5.443-1.418-7.21-5.73-1.077-6.03 1.464l-4.727-10.106c-4.502 9.267-13.707 1.37-23.743 3.711-5.12 1.206-11.537.688-14.242-3.823a16.7 16.7 0 0 0 3.782-4.537 15.3 15.3 0 0 1-4.808.609 10.08 10.08 0 0 1 4.457-8.135c1.443-.944-2.13-4.302-.87-5.484 2.584-2.412 4.318-.774 5.844-3.954a11.75 11.75 0 0 1 10.613-6.488c4.387.102 12.247.06 13.95 4.102 5.424-3.551 12.975-2.548 18.277 1.177 4.407 3.084 9.423 12.407 10.53 17.67 1.107 5.262-1.332 21.348-4.122 25.934"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M246.5 101.003H74.852a12.21 12.21 0 0 1-12.325-11.18A12.007 12.007 0 0 1 74.5 77.003h172a12 12 0 0 1 0 24"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M345.236 120.503H63a1 1 0 0 1 0-2h282.236a1 1 0 0 1 0 2"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M333.5 101.503h-259a12.5 12.5 0 0 1 0-25h259a12.5 12.5 0 0 1 0 25m-259-23a10.5 10.5 0 0 0 0 21h259a10.5 10.5 0 0 0 0-21Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M169.5 195.003H74.852a12.21 12.21 0 0 1-12.325-11.18 12.007 12.007 0 0 1 11.973-12.82h95a12 12 0 0 1 0 24"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M345.236 214.503H63a1 1 0 0 1 0-2h282.236a1 1 0 0 1 0 2"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M333.5 195.503h-259a12.5 12.5 0 0 1 0-25h259a12.5 12.5 0 0 1 0 25m-259-23a10.5 10.5 0 0 0 0 21h259a10.5 10.5 0 0 0 0-21Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M296.5 289.003H74.852a12.21 12.21 0 0 1-12.325-11.18 12.007 12.007 0 0 1 11.973-12.82h222a12 12 0 0 1 0 24"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M345.236 308.503H63a1 1 0 0 1 0-2h282.236a1 1 0 0 1 0 2"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M333.5 289.503h-259a12.5 12.5 0 0 1 0-25h259a12.5 12.5 0 0 1 0 25m-259-23a10.5 10.5 0 0 0 0 21h259a10.5 10.5 0 0 0 0-21Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M230.214 88.806h-2V11.763h144.657v2H230.214z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 379.054,
  cy: 11.946,
  r: 11.946,
  fill: "#ccc"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M160.786 182.806h2v-44.043H18.129v2h142.657z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.946,
  cy: 138.946,
  r: 11.946,
  fill: "#ccc"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M296.214 280.201h-2v55.043h122.657v-2H296.214z"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 423.054,
  cy: 335.06,
  r: 11.946,
  fill: "#ccc"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#cacaca",
  d: "m699.556 597.47-271.75.307a1.19 1.19 0 1 1 0-2.382l271.75-.307a1.19 1.19 0 0 1 0 2.381"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M590.08 177.506a4.46 4.46 0 0 0-6.043-1.433c1.47-2.042.362-5.533-1.942-6.944-2.61-1.6-5.908-1.334-8.952-1.016l-24.957 2.606c-2.878.3-5.835.625-8.396 1.97s-4.67 3.97-4.521 6.86a14.36 14.36 0 0 0-6.122-.83c-2.051.323-4.074 1.822-4.293 3.887-.352 3.314 3.585 5.228 6.792 6.137l17.86 5.06-1.835.393a76.1 76.1 0 0 0 34.455-4.985c2.509-.989 5.048-2.173 6.804-4.219s2.523-5.166 1.15-7.486"
})));
export default SvgManWithProgressbarYellowIcon;